// hooks
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { FormulaType } from '../../constants/formulaType';

// constants
import { BaseError } from '../../helpers/BaseError';

import topicKeys from 'hooks/topic-management/_queryKeys';

// models
import {
    ContentCardType,
    FormulaCreateModel,
    FormulaDetailModel,
    FormulaTypesData,
} from '../../models/formula.model';

import API from '../../services/api';

import formulaSequencesKeys from '../formula-sequence/__queryKeys';
import useAnalytics from '../helper/useAnalytics';
import formulaKeys from './_queryKeys';

const useFormulaCreateMutation = (
    message_type: FormulaType | null,
    sequenceId?: string,
) => {
    const queryClient = useQueryClient();

    const { track } = useAnalytics();

    return useMutation<
        AxiosResponse<FormulaDetailModel>,
        BaseError,
        FormulaCreateModel
    >({
        mutationFn: (createBody: FormulaCreateModel) =>
            API.createFormula({
                ...createBody,
                message_type: message_type ?? createBody.message_type,
                content_card_type:
                    message_type ??
                    createBody?.message_type === FormulaType.contentCards
                        ? createBody.content_card_type ||
                          ContentCardType.TextOnly
                        : undefined,
                structure:
                    createBody.structure ||
                    FormulaTypesData[
                        message_type ?? createBody.message_type!
                    ].getTemplate({
                        content_card_type:
                            createBody.content_card_type ||
                            ContentCardType.TextOnly,
                    }),
                labels: createBody.labels || [],
            }),

        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({ queryKey: topicKeys.all() });
            if (sequenceId) {
                queryClient.invalidateQueries({
                    queryKey: formulaSequencesKeys.detail(sequenceId),
                });
            }
            track('formula_created', {
                formula_id: data.data.id,
            });
        },
    });
};

export default useFormulaCreateMutation;
